import React from 'react';
import { DefaultSearchSortFilter } from '@juno/ui';
import { useQuerySearch } from '@juno/utils';
import { useDirectoryData } from '../Contexts/DirectoryContext';
import { DirectorySort, useDirectoryFilters } from '../Contexts/DirectoryFiltersContext';

interface DirectoryHeaderProps {
  setFiltersOpen: (value: React.SetStateAction<boolean>) => void;
  filtersOpen: boolean;
}

const DirectoryHeader: React.FC<DirectoryHeaderProps> = ({ setFiltersOpen, filtersOpen }) => {
  const { localSearch, setLocalSearch } = useQuerySearch();
  const { showMentorshipFilter, showTagsFilter } = useDirectoryData();
  const { setSort, sort, resetPage } = useDirectoryFilters();

  const areFiltersAvailable = showTagsFilter || showMentorshipFilter;

  if (!areFiltersAvailable) {
    return null;
  }

  return (
    <DefaultSearchSortFilter
      showButton={false}
      buttonDisabled={true}
      buttonText={''}
      onClickButton={() => {}}
      search={localSearch}
      setSearch={(value) => {
        resetPage();
        setLocalSearch(value);
      }}
      sort={sort}
      setSort={(value) => {
        resetPage();
        setSort(value as DirectorySort);
      }}
      sortOptions={[
        { value: DirectorySort.FIRSTNAME, label: 'First Name' },
        { value: DirectorySort.LASTNAME, label: 'Last Name' },
      ]}
      onClickFilter={() => setFiltersOpen((prev) => !prev)}
      isFilterSelected={filtersOpen}
    />
  );
};

export default DirectoryHeader;
